<template>
  <form>
    <div class="row mb-2">
      <div class="col-sm-12">

        <div class="row mt-2" v-if="isAdmin">
          <label for="isProvider" class="col-sm-4 col-form-label text-capitalize-first">{{ helper.trans("labels.is_provider") }}</label>
          <div class="col-sm-8">
            <div class="form-check form-switch d-flex align-items-center">
              <input v-model="form.isProvider" class="form-check-input" type="checkbox" id="isProvider">
            </div>
          </div>
        </div>

        <div class="row mt-2">
          <label for="name" class="col-sm-4 col-form-label text-capitalize-first">{{ helper.trans("labels.name") }}</label>
          <div class="col-sm-8">
            <FormInputWrapper v-slot="parentProps" :errors="getErrors(`name`)">
              <input :class="parentProps.class" v-model="form.name" type="text" class="form-control " id="name">
            </FormInputWrapper>
          </div>
        </div>

        <div class="row mt-2">
          <label for="email" class="col-sm-4 col-form-label text-capitalize-first">{{ helper.trans("labels.email") }}</label>
          <div class="col-sm-8">
            <FormInputWrapper v-slot="parentProps" :errors="getErrors(`email`)">
              <input v-model="form.email" :class="parentProps.class" :readonly="!!form.id" type="text" class="form-control " id="email">
            </FormInputWrapper>
          </div>
        </div>

        <div class="row mt-2" v-if="isAdmin">
          <label for="appId" class="col-sm-4 col-form-label text-capitalize-first">{{ helper.trans("labels.domain") }}</label>
          <div class="col-sm-8">
            <FormInputWrapper v-slot="parentProps" :errors="getErrors(`appId`)">
              <Multiselect id="appId"
                           class=""
                           :class="parentProps.class"
                           v-model="form.appId"
                           :options="store.getters['getAppsIds']"
                           :custom-label="(opt) => store.getters['getAppById'](opt)?.domain"
                           select-label="Select"
                           placeholder=""
                           open-direction="bottom"
                           :multiple="false"
                           :searchable="true"
                           :internal-search="true"
                           :clear-on-select="false"
                           :close-on-select="true"
                           :options-limit="100"
                           :limit="1000"
                           :show-no-results="false"
                           :hide-selected="false"
              >
              </Multiselect>
            </FormInputWrapper>
          </div>
        </div>

        <div class="row mt-2">
          <label for="tgChatGroupId" class="col-sm-4 col-form-label text-capitalize-first">{{ helper.trans("labels.telegram_chat_id") }}</label>
          <div class="col-sm-8">
            <FormInputWrapper v-slot="parentProps" :errors="getErrors(`tgChatGroupId`)">
              <input :class="parentProps.class" v-model="form.tgChatGroupId" type="text" class="form-control " id="tgChatGroupId">
            </FormInputWrapper>
          </div>
        </div>

        <div class="row mt-2" v-if="form.isProvider">
          <label for="tgLowBalanceChatGroupId" class="col-sm-4 col-form-label text-capitalize-first">{{ helper.trans("labels.provider_low_balance_chat_id") }}</label>
          <div class="col-sm-8">
            <FormInputWrapper v-slot="parentProps" :errors="getErrors(`tgLowBalanceChatGroupId`)">
              <input :class="parentProps.class" v-model="form.tgLowBalanceChatGroupId" :placeholder="form.tgChatGroupId || ''" type="text" class="form-control" id="tgLowBalanceChatGroupId">
            </FormInputWrapper>
            <small class="text-muted d-block mt-1">{{ helper.trans("labels.provider_low_balance_chat_id_hint") }}</small>
          </div>
        </div>

        <div class="row mt-2">
          <label for="insuranceLimitUSDT" class="col-sm-4 col-form-label text-capitalize-first">{{ helper.trans("labels.insurance_limit") }}</label>
          <div class="col-sm-8">
            <FormInputWrapper v-slot="parentProps" :errors="getErrors(`insuranceLimitUSDT`)">
              <input v-model="form.insuranceLimitUSDT" :class="parentProps.class" type="text" class="form-control " id="insuranceLimitUSDT">
            </FormInputWrapper>
          </div>
        </div>

        <div class="row mt-2">
          <label for="isManualWithdrawals" class="col-sm-4 col-form-label text-capitalize-first">{{ helper.trans("labels.isManualWithdrawals") }}</label>
          <div class="col-sm-8">
            <div class="form-check form-switch d-flex align-items-center">
              <input  v-model="form.isManualWithdrawals" class="form-check-input" type="checkbox" id="isManualWithdrawals">
            </div>
          </div>
        </div>

        <div class="row mt-2">
          <label for="withdrawalAddress" class="col-sm-4 col-form-label text-capitalize-first">{{ helper.trans("labels.withdrawalAddress") }}</label>
          <div class="col-sm-8">
            <FormInputWrapper v-slot="parentProps" :errors="getErrors(`withdrawalAddress`)">
              <input v-model="form.withdrawalAddress" :class="parentProps.class" type="text" class="form-control " id="withdrawalAddress">
            </FormInputWrapper>
          </div>
        </div>

        <div class="row mt-2">
          <label for="isPayInTrafficBlocked" class="col-sm-4 col-form-label text-capitalize-first">{{ helper.trans("labels.is_pay_in_traffic_blocked") }}</label>
          <div class="col-sm-8">
            <div class="form-check form-switch d-flex align-items-center">
              <input  v-model="form.isPayInTrafficBlocked" class="form-check-input" type="checkbox" id="isPayInTrafficBlocked">
            </div>
          </div>
        </div>

        <div class="row mt-2">
          <label for="isPayOutTrafficBlocked" class="col-sm-4 col-form-label text-capitalize-first">{{ helper.trans("labels.is_pay_out_traffic_blocked") }}</label>
          <div class="col-sm-8">
            <div class="form-check form-switch d-flex align-items-center">
              <input  v-model="form.isPayOutTrafficBlocked" class="form-check-input" type="checkbox" id="isPayOutTrafficBlocked">
            </div>
          </div>
        </div>

        <div class="row mt-2">
          <label for="isEffectiveRateEnabled" class="col-sm-4 col-form-label text-capitalize-first">{{ helper.trans("labels.show_effective_rate") }}</label>
          <div class="col-sm-8">
            <div class="form-check form-switch d-flex align-items-center">
              <input v-model="form.isEffectiveRateEnabled" class="form-check-input" type="checkbox" id="isEffectiveRateEnabled">
            </div>
          </div>
        </div>

        <div class="row mt-2" v-if="form.id && (isAdmin || isOperator || isTeamLead)">
          <label class="col-sm-4 col-form-label text-capitalize-first">{{ helper.trans("labels.autoCabinetBlock") }}</label>
          <div class="col-sm-8">
            <div class="form-check form-switch d-flex align-items-center">
              <input v-model="form.isAutoCabinetBlockEnabled" class="form-check-input" type="checkbox" id="autoCabinetBlockEnabled">
            </div>
          </div>
        </div>

        <div class="row mt-2" v-if="form.id && (isAdmin || isOperator || isTeamLead) && form.isAutoCabinetBlockEnabled">
          <label class="col-sm-4 col-form-label text-capitalize-first">{{ helper.trans("labels.autoCabinetBlockTimeout") }}</label>
          <div class="col-sm-8 d-flex align-items-center gap-2">
            <FormInputWrapper v-slot="parentProps" :errors="getErrors(`autoCabinetBlockTimeoutMinutes`)">
              <input
                :class="[parentProps.class, 'form-control', 'form-control-sm']"
                v-model="form.autoCabinetBlockTimeoutMinutes"
                type="number"
                min="1"
                id="autoCabinetBlockTimeoutMinutes"
                style="max-width: 120px"
              >
            </FormInputWrapper>
            <span class="text-muted">{{ helper.trans("labels.minutes") }}</span>
            <small v-if="autoCabinetBlockHoursText" class="text-muted">{{ autoCabinetBlockHoursText }}</small>
          </div>
        </div>

        <div class="row mt-2" v-if="form.id && (isAdmin || isOperator || isTeamLead) && form.isAutoCabinetBlockEnabled">
          <label class="col-sm-4 col-form-label text-capitalize-first">{{ helper.trans("labels.autoCabinetBlockScope") }}</label>
          <div class="col-sm-8">
            <div class="form-check small mb-0">
              <input class="form-check-input" v-model="form.isAutoCabinetBlockPayInEnabled" type="checkbox" id="autoCabinetBlockPayIn">
              <label class="form-check-label" for="autoCabinetBlockPayIn">
                {{ helper.trans("labels.autoCabinetBlockScopePayIn") }}
              </label>
            </div>
            <div class="form-check small mb-0">
              <input class="form-check-input" v-model="form.isAutoCabinetBlockPayOutEnabled" type="checkbox" id="autoCabinetBlockPayOut">
              <label class="form-check-label" for="autoCabinetBlockPayOut">
                {{ helper.trans("labels.autoCabinetBlockScopePayOut") }}
              </label>
            </div>
          </div>
        </div>

        <div class="row mt-2" v-if="form.id && isAdmin">
          <label for="isPayOutDisputeReminderToGroupChat" class="col-sm-4 col-form-label text-capitalize-first">{{ helper.trans("labels.pay_out_dispute_reminder_to_group_chat") }}</label>
          <div class="col-sm-8">
            <div class="form-check form-switch d-flex align-items-center">
              <input :checked="form.isPayOutDisputeReminderToGroupChat" @click.prevent="togglePayOutDisputeReminderToGroupChat" :disabled="isPayOutDisputeReminderToggleLoading" class="form-check-input" type="checkbox" id="isPayOutDisputeReminderToGroupChat">
            </div>
            <small v-if="form.isPayOutDisputeReminderToGroupChat && !form.tgChatGroupId" class="text-warning d-block mt-1">
              {{ helper.trans("labels.pay_out_dispute_reminder_to_group_chat_no_group_warning") }}
            </small>
          </div>
        </div>

        <div class="row mt-2" v-if="form.id && concurrentDealsLimitEnabled && isAdmin">
          <label for="isConcurrentDealsLimitEnabled" class="col-sm-4 col-form-label text-capitalize-first">{{ helper.trans("labels.concurrent_deals_limit") }}</label>
          <div class="col-sm-8">
            <div class="d-flex align-items-center gap-2">
              <div class="form-check form-switch d-flex align-items-center mb-0">
                <input v-model="form.isConcurrentDealsLimitEnabled" class="form-check-input" type="checkbox" id="isConcurrentDealsLimitEnabled">
              </div>
              <FormInputWrapper v-slot="parentProps" :errors="getErrors(`concurrentDealsLimit`)">
                <input
                  :class="[parentProps.class, 'form-control', 'form-control-sm']"
                  v-model.number="form.concurrentDealsLimit"
                  :disabled="!form.isConcurrentDealsLimitEnabled"
                  type="number"
                  min="1"
                  id="concurrentDealsLimit"
                  style="max-width: 120px"
                >
              </FormInputWrapper>
            </div>
            <small class="text-muted d-block mt-1">{{ helper.trans("labels.concurrent_deals_limit_hint") }}</small>
          </div>
        </div>

        <div class="row mt-2" v-if="!form.id">
          <label for="createInvite" class="col-sm-4 col-form-label text-capitalize-first">{{ helper.trans("labels.create_invite") }}</label>
          <div class="col-sm-8">
            <div class="form-check form-switch d-flex align-items-center">
              <input  v-model="form.createInvite" class="form-check-input" type="checkbox" id="createInvite">
            </div>
          </div>
        </div>

        <div class="row mt-2" v-if="form.id">
          <label for="2fa" class="col-sm-4 col-form-label text-capitalize-first">{{ helper.trans("labels.2fa") }}</label>
          <div class="col-sm-8 align-items-center d-flex">
            <span v-if="form?.is2faEnabled" class="text-success">{{ helper.trans('labels.enabled')}}</span>
            <span v-if="!form?.is2faEnabled" class="text-warning"><i class="fa fa-warning"></i> {{ helper.trans('labels.disabled')}}</span>
            <button v-if="form?.is2faEnabled" type="button" class="btn btn-danger ms-2 btn-sm text-capitalize-first" @click.prevent="disable2fa(form.id)">{{ helper.trans("labels.disable")}}</button>
          </div>
        </div>

        <div class="row mt-2" v-if="(form.id || form.createInvite === false) && store.getters.hasPermission(UserPermission.RESET_TRADER_PASSWORD)">
          <label for="password" class="col-sm-4 col-form-label text-capitalize-first">{{ helper.trans("labels.password") }}</label>
          <div class="col-sm-8">
            <FormInputWrapper v-slot="parentProps" :errors="getErrors(`password`)" >
              <div class="input-group" :class="parentProps.class">
                <input v-model="form.password" :class="parentProps.class" type="text" class="form-control " id="password">
                <button @click.prevent="form.password = helper.generatePassword()" type="button" class="btn btn-outline-secondary"><i class="fa fa-rotate"></i></button>
              </div>
            </FormInputWrapper>
          </div>
        </div>

        <div v-if="isAdmin" class="">
          <div class="row mt-2" v-for="(teamLead, index) in form.teamLeads" :key="index">
            <div class="col-sm-4">
              <label :for="`teamLead${index}`" class="col-form-label text-capitalize-first">{{ helper.trans("labels.teamlead") }} L{{ index + 1}}</label>
              <span v-if="teamLead && form.mainTeamLead?.id !== teamLead?.id" @click.prevent="setMainTeamLead(teamLead)" class="badge border border-primary text-primary ms-2" style="cursor: pointer">main</span>
              <span v-else-if="teamLead" class="badge border border-primary bg-primary ms-2">main</span>

              <span v-if="teamLead" @click.prevent="toggleTeamLeadVisibility(teamLead)" class="badge border border-dark text-dark ms-2" style="cursor: pointer; width: 35px">
                <i v-if="form.hiddenTeamLeads.includes(teamLead.id)" class="fa fa-eye-slash"></i>
                <i v-else class="fa fa-eye"></i>
              </span>
            </div>
            <div class="col-sm-8">
              <FormInputWrapper v-slot="parentProps" :errors="getErrors(`teamLead${index}`)">
                <Multiselect :id="`teamLead${index}`"
                             class=""
                             :class="parentProps.class"
                             v-model="form.teamLeads[index]"
                             track-by="id"
                             :options="teamLeads"
                             :custom-label="(opt) => `${opt.name} (${opt.email})`"
                             :custom-value="(opt) => opt.id"
                             select-label="Select"
                             placeholder=""
                             open-direction="bottom"
                             :multiple="false"
                             :searchable="true"
                             :internal-search="true"
                             :clear-on-select="false"
                             :close-on-select="true"
                             :options-limit="100"
                             :limit="1000"
                             :show-no-results="false"
                             :hide-selected="false"
                             @search-change="asyncFindTeamLeads"
                             :loading="isTeamLeadsSelectLoading"
                >
                </Multiselect>
              </FormInputWrapper>
            </div>
          </div>
        </div>

        <div class="row mt-2" v-if="isAdmin">
          <label for="comment" class="col-sm-4 col-form-label text-capitalize-first">{{ helper.trans("labels.comment") }}</label>
          <div class="col-sm-8">
            <FormInputWrapper v-slot="parentProps" :errors="getErrors(`comment`)">
              <textarea :class="parentProps.class" rows="3" v-model="form.comment" class="form-control " id="comment"></textarea>
            </FormInputWrapper>
          </div>
        </div>

        <div class="row mt-2" v-if="isAdmin && form.id">
          <label class="col-sm-4 col-form-label text-capitalize-first">
            {{ helper.trans("labels.anti_fraud.pay_in_canceled_count") }}
          </label>
          <div class="col-sm-8 mt-1">
            <FormInputWrapper v-slot="parentProps" :errors="getErrors(`antiFraudSettings.payInCanceledCount`)">
              <input
                :class="[parentProps.class, 'w-50']"
                v-model="antiFraudSettings.payInCanceledCount"
                type="number"
                class="form-control form-control-sm"
                id="payInCanceledCount"
                :readonly="!isAdmin"
                min="0"
                @input="antiFraudSettings.payInCanceledCount = Math.max(0, Number($event.target.value) || 0)"
              >
            </FormInputWrapper>
          </div>
        </div>

        <div class="row mt-2" v-if="isAdmin && form.id">
          <label class="col-sm-4 col-form-label text-capitalize-first">
            {{ helper.trans("labels.anti_fraud.active_disputes_threshold") }}
          </label>
          <div class="col-sm-8 mt-1">
            <FormInputWrapper v-slot="parentProps" :errors="getErrors(`antiFraudSettings.activeDisputesThreshold`)">
              <input
                :class="[parentProps.class, 'w-50']"
                v-model="antiFraudSettings.activeDisputesThreshold"
                type="number"
                class="form-control form-control-sm"
                id="activeDisputesThreshold"
                :readonly="!isAdmin"
                min="1"
                @input="antiFraudSettings.activeDisputesThreshold = ($event.target as HTMLInputElement).value === '' ? null : Math.max(1, Number(($event.target as HTMLInputElement).value) || 0)"
              >
            </FormInputWrapper>
          </div>
        </div>

        <div class="row mt-2" v-if="isAdmin && form.id && stopScamEnabled">
          <label class="col-sm-4 col-form-label text-capitalize-first">
            {{ helper.trans("labels.anti_fraud.pay_out_fake_receipts_limit") }}
          </label>
          <div class="col-sm-8 mt-1">
            <FormInputWrapper v-slot="parentProps" :errors="getErrors(`antiFraudSettings.payOutFakeReceiptsLimit`)">
              <input
                :class="[parentProps.class, 'w-50']"
                v-model="antiFraudSettings.payOutFakeReceiptsLimit"
                type="number"
                class="form-control form-control-sm"
                id="payOutFakeReceiptsLimit"
                min="0"
                @input="antiFraudSettings.payOutFakeReceiptsLimit = ($event.target as HTMLInputElement).value === '' ? null : Math.max(0, Number(($event.target as HTMLInputElement).value) || 0)"
              >
            </FormInputWrapper>
            <small class="text-secondary">
              {{ helper.trans("labels.anti_fraud.pay_out_fake_receipts_count") }}: {{ antiFraudSettings.payOutFakeReceiptsCount }}
            </small>
          </div>
        </div>

        <div class="row mt-2" v-if="isAdmin">
          <label for="disabledAfRules" class="col-sm-4 col-form-label text-capitalize-first">{{ helper.trans("labels.disabledAfRules") }}</label>
          <div class="col-sm-8">
            <FormInputWrapper v-slot="parentProps" :errors="getErrors(`disabledAfRules`)">
              <Multiselect id="disabledAfRules"
                           class=""
                           :class="parentProps.class"
                           v-model="form.disabledAfRules"
                           :options="Object.values(AntiFraudAlertRule)"
                           :custom-label="(opt) => helper.trans(`antifraudalerts.rule.${opt}`)"
                           select-label="Select"
                           placeholder=""
                           open-direction="bottom"
                           :multiple="true"
                           :searchable="true"
                           :internal-search="true"
                           :clear-on-select="false"
                           :close-on-select="true"
                           :options-limit="100"
                           :limit="1000"
                           :show-no-results="false"
                           :hide-selected="false"
              >
              </Multiselect>
            </FormInputWrapper>
          </div>
        </div>

        <div class="row mt-2" v-if="isAdmin">
          <label for="isAlfaCardsEnabled" class="col-sm-4 col-form-label text-capitalize-first">{{ helper.trans("labels.is_alfa_cards_enabled") }}</label>
          <div class="col-sm-8">
            <div class="form-check form-switch d-flex align-items-center">
              <input  v-model="form.isAlfaCardsEnabled" class="form-check-input" type="checkbox" id="isAlfaCardsEnabled">
            </div>
          </div>
        </div>

        <div class="row mt-2" v-if="deviceSumCheckDisablingEnabled && (isAdmin || isOperator)">
          <label for="isDeviceSumCheckDisabled" class="col-sm-4 col-form-label text-capitalize-first">{{ helper.trans("labels.is_device_sum_check_disabled") }}</label>
          <div class="col-sm-8">
            <div class="form-check form-switch d-flex align-items-center">
              <input v-model="form.isDeviceSumCheckDisabled" :disabled="!isAdmin" @click="onDeviceSumCheckDisabledClick" class="form-check-input" type="checkbox" id="isDeviceSumCheckDisabled">
            </div>
          </div>
        </div>

        <div class="row mt-2" v-if="isAdmin">
          <label for="isAvailable24" class="col-sm-4 col-form-label text-capitalize-first">{{ helper.trans("labels.isAvailable24") }}</label>
          <div class="col-sm-8">
            <div class="form-check form-switch d-flex align-items-center">
              <input  v-model="form.isAvailable24" class="form-check-input" type="checkbox" id="isAvailable24">
            </div>
          </div>
        </div>

        <div class="row mt-2" v-if="isAdmin">
          <label for="isRequisitesReuseEnable" class="col-sm-4 col-form-label text-capitalize-first">{{ helper.trans("labels.isRequisitesReuseEnable") }}</label>
          <div class="col-sm-8">
            <div class="form-check form-switch d-flex align-items-center">
              <input  v-model="form.isRequisitesReuseEnable" class="form-check-input" type="checkbox" id="isRequisitesReuseEnable">
            </div>
          </div>
        </div>

        <div class="row mt-2" v-if="form.isProvider">
          <label for="isProviderLowBalanceAlertEnabled" class="col-sm-4 col-form-label text-capitalize-first">{{ helper.trans("labels.provider_low_balance_alert") }}</label>
          <div class="col-sm-8">
            <div class="form-check form-switch d-flex align-items-center">
              <input v-model="form.isProviderLowBalanceAlertEnabled" class="form-check-input" type="checkbox" id="isProviderLowBalanceAlertEnabled">
            </div>
          </div>
        </div>

        <div class="row mt-2" v-if="form.isProvider && providerCustomLowBalanceThresholdEnabled">
          <label for="providerLowBalanceThreshold" class="col-sm-4 col-form-label text-capitalize-first">{{ helper.trans("labels.provider_low_balance_threshold") }}</label>
          <div class="col-sm-8">
            <FormInputWrapper v-slot="parentProps" :errors="getErrors(`providerLowBalanceThreshold`)">
              <input :class="parentProps.class" v-model="form.providerLowBalanceThreshold" v-maska data-maska="9.########" data-maska-tokens="9:[0-9]:multiple" inputmode="decimal" type="text" class="form-control" id="providerLowBalanceThreshold">
            </FormInputWrapper>
            <small class="text-muted d-block mt-1">{{ helper.trans("labels.provider_low_balance_threshold_hint") }}</small>
          </div>
        </div>

        <div class="row mt-2">
          <label for="disputeAutoClosePeriodMinutes" class="col-sm-4 col-form-label text-capitalize-first">
            {{ helper.trans("labels.disputeAutoClosePeriodMinutes") }}
          </label>
          <div class="col-sm-2">
            <FormInputWrapper v-slot="parentProps" :errors="getErrors(`disputeAutocloseAt`)">
              <input
                v-model="form.disputeAutoClosePeriodMinutes"
                :class="parentProps.class"
                type="text"
                class="form-control form-control-sm"
                id="disputeAutoClosePeriodMinutes"
              >
            </FormInputWrapper>
          </div>
        </div>

        <div class="row mt-2" v-if="isAdmin">
          <label class="col-sm-4 col-form-label text-capitalize-first">
            {{ helper.trans("labels.nightDisputeAutoClose") }}
          </label>
          <div class="col-sm-8 d-flex align-items-end gap-2">
            <div class="flex-grow-0" style="min-width: 80px;">
              <small class="text-muted d-block mb-1" style="font-size: 11px;">{{ helper.trans("labels.hours") }}</small>
              <FormInputWrapper v-slot="parentProps" :errors="getErrors(`nightDisputeAutoCloseHour`)">
                <input
                  v-model.number="form.nightDisputeAutoCloseHour"
                  @change="onNightDisputeAutoCloseHourChange"
                  :class="parentProps.class"
                  type="number"
                  min="4"
                  max="14"
                  class="form-control form-control-sm"
                  id="nightDisputeAutoCloseHour"
                >
              </FormInputWrapper>
            </div>
            <span class="mb-2" style="font-size: 16px; font-weight: bold;">:</span>
            <div class="flex-grow-0" style="min-width: 80px;">
              <small class="text-muted d-block mb-1" style="font-size: 11px;">{{ helper.trans("labels.minutes") }}</small>
              <FormInputWrapper v-slot="parentProps" :errors="getErrors(`nightDisputeAutoCloseMinutes`)">
                <input
                  v-model.number="form.nightDisputeAutoCloseMinutes"
                  @change="onNightDisputeAutoCloseMinutesChange"
                  :class="parentProps.class"
                  type="number"
                  min="0"
                  max="59"
                  class="form-control form-control-sm"
                  id="nightDisputeAutoCloseMinutes"
                >
              </FormInputWrapper>
            </div>
          </div>
        </div>

        <div class="row mt-2" v-if="isAdmin">
          <label for="payInRateSource" class="col-sm-4 col-form-label text-capitalize-first">{{ helper.trans("labels.rate_source") }}, in</label>
          <div class="col-sm-8">
            <FormInputWrapper v-slot="parentProps" :errors="getErrors(`payInRateSource`)">
              <Multiselect id="payInRateSource"
                           class=""
                           :class="parentProps.class"
                           v-model="form.payInRateSource"
                           :options="store.getters['rateSources/all']"
                           :custom-label="(opt: any) => store.getters['rateSources/get'](opt)?.name"
                           select-label="Select"
                           placeholder=""
                           open-direction="bottom"
                           :multiple="false"
                           :searchable="true"
                           :internal-search="true"
                           :clear-on-select="false"
                           :close-on-select="true"
                           :options-limit="100"
                           :limit="1000"
                           :show-no-results="false"
                           :hide-selected="false"
              >
              </Multiselect>
            </FormInputWrapper>
          </div>
        </div>

        <div class="row mt-2" v-if="isAdmin">
          <label for="payOutRateSource" class="col-sm-4 col-form-label text-capitalize-first">{{ helper.trans("labels.rate_source") }}, out</label>
          <div class="col-sm-8">
            <FormInputWrapper v-slot="parentProps" :errors="getErrors(`payOutRateSource`)">
              <Multiselect id="payOutRateSource"
                           class=""
                           :class="parentProps.class"
                           v-model="form.payOutRateSource"
                           :options="store.getters['rateSources/all']"
                           :custom-label="(opt: any) => store.getters['rateSources/get'](opt)?.name"
                           select-label="Select"
                           placeholder=""
                           open-direction="bottom"
                           :multiple="false"
                           :searchable="true"
                           :internal-search="true"
                           :clear-on-select="false"
                           :close-on-select="true"
                           :options-limit="100"
                           :limit="1000"
                           :show-no-results="false"
                           :hide-selected="false"
              >
              </Multiselect>
            </FormInputWrapper>
          </div>
        </div>

        <div class="row mt-2" v-if="isAdmin">
          <label for="payInFixedRate" class="col-sm-4 col-form-label text-capitalize-first">{{ helper.trans("labels.fixedRatePayIn") }}</label>
          <div class="col-sm-8">
            <FormInputWrapper v-slot="parentProps" :errors="getErrors(`payInFixedRate`)" class="row">
              <div class="col-sm-3" :class="parentProps.class">
                <input v-model="form.payInFixedRate" type="text" class="form-control " id="payInFixedRate"
                       :class="parentProps.class"
                >
              </div>
            </FormInputWrapper>
          </div>
        </div>

        <div class="row mt-2" v-if="isAdmin">
          <label for="payOutFixedRate" class="col-sm-4 col-form-label text-capitalize-first">{{ helper.trans("labels.fixedRatePayOut") }}</label>
          <div class="col-sm-8">
            <FormInputWrapper v-slot="parentProps" :errors="getErrors(`payOutFixedRate`)" class="row">
              <div class="col-sm-3" :class="parentProps.class">
                <input v-model="form.payOutFixedRate" type="text" class="form-control " id="payOutFixedRate"
                       :class="parentProps.class"
                >
              </div>
            </FormInputWrapper>
          </div>
        </div>

        <div class="row mt-3" v-if="isAdmin">
          <div class="col-sm-12">
            <div class="card">
              <div class="card-header">
                <div class="form-check form-switch d-flex align-items-center">
                  <input v-model="showRequisitesLimits" class="form-check-input" type="checkbox" id="showRequisitesLimits">
                  <label class="form-check-label ms-2" for="showRequisitesLimits">
                    {{ helper.trans("labels.requisites_limits") }}
                  </label>
                </div>
                <small class="text-muted">{{ helper.trans("labels.requisites_limits_description") }}</small>
              </div>
              
              <div class="card-body" v-if="showRequisitesLimits">
                <div v-for="(limit, index) in form.requisitesLimits" :key="index" class="row mb-3">
                  <div class="col-sm-4 pe-2">
                    <label class="form-label text-capitalize-first">{{ helper.trans("labels.currency") }}</label>
                    <FormInputWrapper v-slot="parentProps" :errors="getErrors(`requisitesLimits.${index}.currency`)">
                      <Multiselect
                        class="multiselect-sm"
                        :class="parentProps.class"
                        v-model="limit.currency"
                        :options="store.getters['currencyMethods/currencies']"
                        :searchable="true"
                        :close-on-select="true"
                        :placeholder="helper.trans('placeholders.select_currency')"
                      />
                    </FormInputWrapper>
                  </div>
                  <div class="col-sm-4 pe-2">
                    <label class="form-label text-capitalize-first">{{ helper.trans("labels.min_amount_for_deal") }}</label>
                    <div class="d-flex align-items-stretch gap-2">
                      <FormInputWrapper v-slot="parentProps" :errors="getErrors(`requisitesLimits.${index}.amountLimitForDeal`)" class="flex-grow-1">
                        <input 
                          v-model="limit.amountLimitForDeal" 
                          :class="parentProps.class"
                          type="text" 
                          class="form-control form-control-sm"
                          :placeholder="helper.trans('placeholders.enter_amount')"
                        >
                      </FormInputWrapper>
                    </div>
                  </div>
                  <div class="col-sm-4">
                    <label class="form-label text-capitalize-first">{{ helper.trans("labels.max_amount_for_deal") }}</label>
                    <div class="d-flex align-items-stretch gap-2">
                      <FormInputWrapper v-slot="parentProps" :errors="getErrors(`requisitesLimits.${index}.maxAmountLimitForDeal`)" class="flex-grow-1">
                        <input 
                          v-model="limit.maxAmountLimitForDeal" 
                          :class="parentProps.class"
                          type="text" 
                          class="form-control form-control-sm"
                          :placeholder="helper.trans('placeholders.enter_amount')"
                        >
                      </FormInputWrapper>
                      <button 
                        type="button" 
                        @click="removeRequisitesLimit(index)"
                        class="btn btn-outline-danger text-nowrap btn-sm"
                        v-b-tooltip.hover :title="helper.trans('labels.remove_requisites_limit')"
                      >
                        <i class="fa fa-trash"></i>
                      </button>
                    </div>
                  </div>
                </div>
                
                <div class="row">
                  <div class="col-sm-12">
                    <button 
                      type="button" 
                      @click="addRequisitesLimit"
                      class="btn btn-outline-primary btn-sm"
                    >
                      <i class="fa fa-plus"></i> {{ helper.trans("labels.add_requisites_limit") }}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <TraderPlanSettingsBlock 
          :trader="form" 
          @plan-updated="handlePlanUpdate"
        />

      </div>
    </div>
    <ConfirmModal ref="tradersConfirmModal"></ConfirmModal>
  </form>
  <Teleport to="body">
    <div v-if="deviceSumCheckConfirmModal" class="modal fade show d-block" tabindex="-1" style="z-index: 100000">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title text-capitalize-first">{{ helper.trans('labels.is_device_sum_check_disabled') }}</h5>
          </div>
          <div class="modal-body">
            {{ helper.trans('labels.is_device_sum_check_disabled_hint') }}
          </div>
          <div class="modal-footer border-top-0 d-flex justify-content-between">
            <button type="button" class="btn btn-outline-dark btn-sm text-capitalize-first" @click="deviceSumCheckConfirmModal = false">
              {{ helper.trans('button.no') }}
            </button>
            <button type="button" class="btn btn-outline-danger btn-sm text-capitalize-first" @click="confirmDeviceSumCheckDisabled">
              {{ helper.trans('button.yes') }}
            </button>
          </div>
        </div>
      </div>
    </div>
    <div v-if="deviceSumCheckConfirmModal" class="modal-backdrop fade show" style="z-index: 99999"></div>
  </Teleport>
</template>

<script lang="ts">
import {computed, defineComponent, onMounted, reactive, ref, toRefs} from "vue";
import {useStore} from "vuex";
import {helper} from "@/service/CommonHelper";
import {numberFormatter} from "@/service/NumberFormatter";
import Multiselect from "vue-multiselect";
import TraderFormDTO from "@/models/form/TraderFormDTO";
import ValidationErrorDTO from "@/models/ValidationErrorDTO";
import TradersUpdateRequestDTO from "@/models/request/TradersUpdateRequestDTO";
import {UserPermission} from "@/models/enum/UserPermission";
import APIClient from "@/service/APIClient";
import {useNotification} from "@kyvg/vue3-notification";
import TradersCreateRequestDTO from "@/models/request/TradersCreateRequestDTO";
import FormInputWrapper from "@/components/FormInputWrapper.vue";
import {Direction} from "@/models/enum/Direction";
import PaginationDTO from "@/models/PaginationDTO";
import {UserRole} from "@/models/enum/UserRole";
import UserDTO from "@/models/UserDTO";
import ConfirmModal, {ConfirmModalProps} from "@/components/ConfirmModal.vue";
import TraderPlanSettingsBlock from "@/components/TraderPlanSettingsBlock.vue";
import {AntiFraudAlertRule} from "@/models/enum/AntiFraudAlertRule";

const components = {
  Multiselect,
  FormInputWrapper,
  ConfirmModal,
  TraderPlanSettingsBlock
}

const api = new APIClient();
const notification = useNotification()

export default defineComponent({
  props: {},
  emits: ['openAntiFraudSettings', 'updated'],
  components,
  setup(props, { emit }) {
    const notification = useNotification()
    const tradersConfirmModal = ref<InstanceType<typeof ConfirmModal> | null>(null)

    const store = useStore();
    const state = reactive({
      teamLeads: [] as UserDTO[],
      isTeamLeadsSelectLoading: false,
      errors: {} as ValidationErrorDTO[]|any,
      form: {} as TraderFormDTO,
      showRequisitesLimits: false,
      antiFraudSettings: {
        payInCanceledCount: null as number|null,
        activeDisputesThreshold: null as number|null,
        payOutFakeReceiptsLimit: null as number|null,
        payOutFakeReceiptsCount: 0,
      },
      isAntiFraudSettingsLoading: false,
      deviceSumCheckConfirmModal: false,
      isPayOutDisputeReminderToggleLoading: false,
    });

    const setErrors = (data: ValidationErrorDTO[]) => {
      state.errors = {};
      for (const error of data) {
        if (!state.errors.hasOwnProperty(error.field)) {
          state.errors[error.field] = [];
        }
        state.errors[error.field].push(error)
      }
    }

    const save = (): Promise<any> => {
      setErrors([]);
      const form = getForm();

      const requisitesLimitsErrors = validateRequisitesLimits();
      if (requisitesLimitsErrors.length > 0) {
        setErrors(requisitesLimitsErrors);
        return Promise.reject(new Error('Validation failed'));
      }

      const filteredRequisitesLimits = (form.requisitesLimits || [])
        .filter(limit => 
          limit.currency && limit.currency.trim() !== '' && 
          limit.amountLimitForDeal && limit.amountLimitForDeal.trim() !== ''
        )
        .map(limit => ({
          ...limit,
          currency: limit.currency.trim(),
          amountLimitForDeal: limit.amountLimitForDeal.trim(),
          maxAmountLimitForDeal: limit.maxAmountLimitForDeal && limit.maxAmountLimitForDeal.trim() !== ''
            ? limit.maxAmountLimitForDeal.trim()
            : null,
        }));

      let promise;
      if (form.id) {
        if (store.getters.isOperator) {
          promise = (form.password ? api.tradersChangePassword(form.id, form.password) : Promise.resolve())
            .then((resp) => {
              notification.notify({title: helper.trans('traders.notice.updated')});
              return resp;
            });
        } else {
          const { planStatuses, isPayOutDisputeReminderToGroupChat, ...formWithoutPlanStatuses } = form as any;
          const data = {
            ...formWithoutPlanStatuses,
            password: form.password ? form.password : null,
            teamLeadIds: form.teamLeads.map(teamLead => teamLead?.id),
            hiddenTeamLeadIds: form.hiddenTeamLeads,
            mainTeamLeadId: form.mainTeamLead?.id,
            requisitesLimits: filteredRequisitesLimits,
            isProvider: form.isProvider,
            isProviderLowBalanceAlertEnabled: form.isProvider ? !!form.isProviderLowBalanceAlertEnabled : false,
            tgLowBalanceChatGroupId: form.isProvider ? (form.tgLowBalanceChatGroupId || null) : null,
            providerLowBalanceThreshold: normalizeProviderLowBalanceThreshold(form.isProvider, form.providerLowBalanceThreshold),
            planId: form.planId ?? null,
            payInFixedRate: !form.payInFixedRate ? '' : String(Number.parseFloat(String(form.payInFixedRate).replace(/\s/g, ''))),
            payOutFixedRate: !form.payOutFixedRate ? '' : String(Number.parseFloat(String(form.payOutFixedRate).replace(/\s/g, ''))),
            concurrentDealsLimit: normalizeConcurrentDealsLimit(form.concurrentDealsLimit),
          } as TradersUpdateRequestDTO;
          promise = api.tradersUpdate(form.id, data)
            .then(async (resp) => {
              if (form.id) {
                try {
                  await api.traderAntiFraudSettingsUpdateById(form.id, {
                    traderId: form.id,
                    payInCanceledCount: state.antiFraudSettings.payInCanceledCount,
                    activeDisputesThreshold: state.antiFraudSettings.activeDisputesThreshold,
                    payOutFakeReceiptsLimit: state.antiFraudSettings.payOutFakeReceiptsLimit,
                  });
                } catch (e: any) {
                  if (e.response && e.response.status === 400 && e.response.data) {
                    const antiFraudErrors = e.response.data;
                    for (const error of antiFraudErrors) {
                      if (error.field) {
                        if (!state.errors.hasOwnProperty(`antiFraudSettings.${error.field}`)) {
                          state.errors[`antiFraudSettings.${error.field}`] = [];
                        }
                        state.errors[`antiFraudSettings.${error.field}`].push(error);
                      }
                    }
                    throw e;
                  }
                }
              }
              notification.notify({title: helper.trans('traders.notice.updated')});

              return resp;
            })
        }
      } else {
        const { planStatuses, isPayOutDisputeReminderToGroupChat, isConcurrentDealsLimitEnabled, concurrentDealsLimit, ...formWithoutPlanStatuses } = form as any;
        const data = {
          ...formWithoutPlanStatuses,
          password: form.createInvite ? null : (form.password ? form.password : null),
          createInvite: form.createInvite,
          teamLeadIds: form.teamLeads.map(teamLead => teamLead?.id),
          hiddenTeamLeadIds: form.hiddenTeamLeads,
          mainTeamLeadId: form.mainTeamLead?.id,
          requisitesLimits: filteredRequisitesLimits,
          isProvider: form.isProvider,
          isProviderLowBalanceAlertEnabled: form.isProvider ? !!form.isProviderLowBalanceAlertEnabled : false,
          tgLowBalanceChatGroupId: form.isProvider ? (form.tgLowBalanceChatGroupId || null) : null,
          providerLowBalanceThreshold: normalizeProviderLowBalanceThreshold(form.isProvider, form.providerLowBalanceThreshold),
          planId: form.planId ?? null,
          payInFixedRate: !form.payInFixedRate ? '' : String(Number.parseFloat(String(form.payInFixedRate).replace(/\s/g, ''))),
          payOutFixedRate: !form.payOutFixedRate ? '' : String(Number.parseFloat(String(form.payOutFixedRate).replace(/\s/g, ''))),
        } as TradersCreateRequestDTO;

        promise = api.tradersCreate(data)
          .then((resp) => {
            notification.notify({title: helper.trans('traders.notice.created')});

            return resp;
          })
      }

      promise
        .catch((e: any) => {
          if (e.response && e.request && e.request.status === 400 && e.response.data) {
            setErrors(e.response.data)
          } else {
            console.log(e);
          }

        })

      return promise
    }

    const getErrors = (path: string) => {
      if (!state.errors.hasOwnProperty(path)) {
        return [];
      }

      return state.errors[path]
    }

    const hasErrors = (path: string) => {
      return state.errors[path]?.length > 0
    }

    const getForm = (): TraderFormDTO => {
      return state.form
    }

    const setForm = async (form: TraderFormDTO) => {
      state.errors = {}
      state.form = {
        ...form
      }
      if (state.form.isProvider === undefined || state.form.isProvider === null) {
        state.form.isProvider = false;
      }
      if (state.form.isProviderLowBalanceAlertEnabled === undefined || state.form.isProviderLowBalanceAlertEnabled === null) {
        state.form.isProviderLowBalanceAlertEnabled = false;
      }
      if (state.form.isEffectiveRateEnabled === undefined || state.form.isEffectiveRateEnabled === null) {
        state.form.isEffectiveRateEnabled = false;
      }
      if (state.form.isAutoCabinetBlockEnabled === undefined || state.form.isAutoCabinetBlockEnabled === null) {
        state.form.isAutoCabinetBlockEnabled = false;
      }
      if (state.form.autoCabinetBlockTimeoutMinutes === undefined || state.form.autoCabinetBlockTimeoutMinutes === null) {
        state.form.autoCabinetBlockTimeoutMinutes = 1440;
      }
      if (state.form.isAutoCabinetBlockPayInEnabled === undefined || state.form.isAutoCabinetBlockPayInEnabled === null) {
        state.form.isAutoCabinetBlockPayInEnabled = true;
      }
      if (state.form.isAutoCabinetBlockPayOutEnabled === undefined || state.form.isAutoCabinetBlockPayOutEnabled === null) {
        state.form.isAutoCabinetBlockPayOutEnabled = true;
      }
      if (state.form.isPayOutDisputeReminderToGroupChat === undefined || state.form.isPayOutDisputeReminderToGroupChat === null) {
        state.form.isPayOutDisputeReminderToGroupChat = false;
      }
      if (state.form.isConcurrentDealsLimitEnabled === undefined || state.form.isConcurrentDealsLimitEnabled === null) {
        state.form.isConcurrentDealsLimitEnabled = false;
      }
      if (state.form.concurrentDealsLimit === undefined) {
        state.form.concurrentDealsLimit = null;
      }
      state.showRequisitesLimits = !!(form.requisitesLimits && form.requisitesLimits.length > 0)
      
      if (form.id) {
        await loadAntiFraudSettings(form.id);
      } else {
        state.antiFraudSettings = {
          payInCanceledCount: null,
          activeDisputesThreshold: null,
          payOutFakeReceiptsLimit: null,
          payOutFakeReceiptsCount: 0,
        };
      }
    }

    const loadAntiFraudSettings = async (traderId: number) => {
      state.isAntiFraudSettingsLoading = true;
      try {
         const settings = await api.traderAntiFraudSettingsById(traderId);
         state.antiFraudSettings = {
          payInCanceledCount: settings.payInCanceledCount,
          activeDisputesThreshold: settings.activeDisputesThreshold ?? null,
          payOutFakeReceiptsLimit: settings.payOutFakeReceiptsLimit ?? null,
          payOutFakeReceiptsCount: settings.payOutFakeReceiptsCount ?? 0,
         };
       } catch (e: any) {
         state.antiFraudSettings = {
          payInCanceledCount: null,
          activeDisputesThreshold: null,
          payOutFakeReceiptsLimit: null,
          payOutFakeReceiptsCount: 0,
         };
       } finally {
        state.isAntiFraudSettingsLoading = false;
      }
    }

    const asyncFindTeamLeads = async (query: string) => {
      state.isTeamLeadsSelectLoading = true;
      state.teamLeads = (await api.users({limit: 100, offset: 0} as PaginationDTO, {query: query, roles: [UserRole.TRADER_TEAM_LEAD]})).items;
      state.isTeamLeadsSelectLoading = false
    }

    const disable2fa = async (id: number) => {
      tradersConfirmModal.value?.show({
        title: helper.trans('labels.2fa_disable_confirmation'),
        okTitle: null,
        cancelTitle: null,
        onOkClick: async () => {
          try {
            await api.trader2faDisable(id);
            notification.notify({title: helper.trans('labels.2fa_disabled')});
            state.form.is2faEnabled = false
          } finally {
          }
        }
      } as ConfirmModalProps);
    }

    const togglePayOutDisputeReminderToGroupChat = async () => {
      if (!state.form.id || state.isPayOutDisputeReminderToggleLoading) {
        return
      }

      state.isPayOutDisputeReminderToggleLoading = true
      try {
        const traderDTO = await api.setTraderPayOutDisputeReminderToGroupChat(
          state.form.id,
          !state.form.isPayOutDisputeReminderToGroupChat
        )
        state.form.isPayOutDisputeReminderToGroupChat = traderDTO.isPayOutDisputeReminderToGroupChat
        emit('updated', traderDTO)
      } finally {
        state.isPayOutDisputeReminderToggleLoading = false
      }
    }

    const normalizeConcurrentDealsLimit = (value: unknown): number|null => {
      if (value === null || value === undefined || value === '') {
        return null
      }

      return Number(value)
    }

    const normalizeProviderLowBalanceThreshold = (isProvider: boolean, value: string|null|undefined): string|null => {
      if (!isProvider || !store.getters.getAppData?.PROVIDER_CUSTOM_LOW_BALANCE_THRESHOLD_ENABLED) {
        return null
      }

      return String(value ?? '').trim()
    }

    const onDeviceSumCheckDisabledClick = (event: Event) => {
      if (!state.form.isDeviceSumCheckDisabled) {
        event.preventDefault()
        state.deviceSumCheckConfirmModal = true
      }
    }

    const confirmDeviceSumCheckDisabled = () => {
      state.form.isDeviceSumCheckDisabled = true
      state.deviceSumCheckConfirmModal = false
    }

    const setMainTeamLead = (teamLead: UserDTO) => {
      state.form.mainTeamLead = teamLead
    }

    const toggleTeamLeadVisibility = (teamLead: UserDTO) => {
      if (state.form.hiddenTeamLeads.includes(teamLead.id)) {
        state.form.hiddenTeamLeads = state.form.hiddenTeamLeads.filter(id => id !== teamLead.id)
      } else {
        state.form.hiddenTeamLeads.push(teamLead.id)
      }

    }

    const addRequisitesLimit = () => {
      if (!state.form.requisitesLimits) {
        state.form.requisitesLimits = []
      }
      state.form.requisitesLimits.push({
        currency: '',
        amountLimitForDeal: '',
        maxAmountLimitForDeal: ''
      })
    }

    const removeRequisitesLimit = (index: number) => {
      if (state.form.requisitesLimits) {
        state.form.requisitesLimits.splice(index, 1)
      }
    }

    const handlePlanUpdate = (data: { traderId: number, planId: number | null }) => {
      state.form.planId = data.planId
    }

    const onNightDisputeAutoCloseHourChange = () => {
      let value = state.form.nightDisputeAutoCloseHour

      if (value === null || value === undefined || (value as any) === '') {
        state.form.nightDisputeAutoCloseHour = null
        return
      }

      value = Number(value)
      if (Number.isNaN(value)) {
        state.form.nightDisputeAutoCloseHour = null
        return
      }

      value = Math.round(value)
      if (value < 4) {
        value = 4
      }
      if (value > 14) {
        value = 14
      }

      state.form.nightDisputeAutoCloseHour = value
    }

    const onNightDisputeAutoCloseMinutesChange = () => {
      let value = state.form.nightDisputeAutoCloseMinutes

      if (value === null || value === undefined || (value as any) === '') {
        state.form.nightDisputeAutoCloseMinutes = null
        return
      }

      value = Number(value)
      if (Number.isNaN(value)) {
        state.form.nightDisputeAutoCloseMinutes = null
        return
      }

      value = Math.round(value)
      if (value < 0) {
        value = 0
      }
      if (value > 59) {
        value = 59
      }

      state.form.nightDisputeAutoCloseMinutes = value
    }

    const autoCabinetBlockHoursText = computed(() => {
      const minutes = Number(state.form.autoCabinetBlockTimeoutMinutes);
      if (!Number.isFinite(minutes) || minutes <= 0) {
        return '';
      }
      const hours = Math.round((minutes / 60) * 100) / 100;
      return helper.trans('labels.hours_period', {hour: hours});
    });

    const validateRequisitesLimits = (): ValidationErrorDTO[] => {
      const errors: ValidationErrorDTO[] = []
      
      if (!state.form.requisitesLimits || state.form.requisitesLimits.length === 0) {
        return errors
      }

      state.form.requisitesLimits.forEach((limit, index) => {
        if (!limit.currency || limit.currency.trim() === '') {
          errors.push({
            code: 'CURRENCY_REQUIRED',
            field: `requisitesLimits.${index}.currency`,
            message: helper.trans('validation.currency_required')
          })
        }

        if (!limit.amountLimitForDeal || limit.amountLimitForDeal.trim() === '') {
          errors.push({
            code: 'AMOUNT_REQUIRED',
            field: `requisitesLimits.${index}.amountLimitForDeal`,
            message: helper.trans('validation.amount_required')
          })
        }

        if (limit.amountLimitForDeal && limit.amountLimitForDeal.trim() !== '' &&
          limit.maxAmountLimitForDeal && limit.maxAmountLimitForDeal.trim() !== '') {
          const minAmount = Number.parseInt(limit.amountLimitForDeal.replace(/\s/g, ''));
          const maxAmount = Number.parseInt(limit.maxAmountLimitForDeal.replace(/\s/g, ''));
          if (!Number.isNaN(minAmount) && !Number.isNaN(maxAmount) && maxAmount < minAmount) {
            errors.push({
              code: 'MAX_AMOUNT_TOO_LOW',
              field: `requisitesLimits.${index}.maxAmountLimitForDeal`,
              message: helper.trans('validation.max_amount_must_be_greater')
            })
          }
        }
      })

      return errors
    }

    const openAntiFraudSettings = () => {
      if (state.form.id) {
        emit('openAntiFraudSettings', state.form.id);
      }
    }

    onMounted(async () => {
      state.teamLeads = (await api.users({limit: 100, offset: 0} as PaginationDTO, {roles: [UserRole.TRADER_TEAM_LEAD]})).items;
      store.dispatch('loadApps');
    })

    return {
      ...toRefs(state),
      getForm,
      setForm,
      store,
      helper,
      numberFormatter,
      setErrors,
      getErrors,
      hasErrors,
      save,
      Direction,
      UserPermission,
      isAdmin: computed(() => store.getters.isAdmin),
      isOperator: computed(() => store.getters.isOperator),
      deviceSumCheckDisablingEnabled: computed(() => !!store.getters.getAppData?.DEVICE_SUM_CHECK_DISABLING_ENABLED),
      concurrentDealsLimitEnabled: computed(() => !!store.getters.getAppData?.TRADER_CONCURRENT_DEALS_LIMIT_ENABLED),
      providerCustomLowBalanceThresholdEnabled: computed(() => !!store.getters.getAppData?.PROVIDER_CUSTOM_LOW_BALANCE_THRESHOLD_ENABLED),
      stopScamEnabled: computed(() => !!store.getters.getAppData?.af_stopscam_payout_receipt_enabled),
      asyncFindTeamLeads,
      disable2fa,
      togglePayOutDisputeReminderToGroupChat,
      onDeviceSumCheckDisabledClick,
      confirmDeviceSumCheckDisabled,
      tradersConfirmModal,
      setMainTeamLead,
      toggleTeamLeadVisibility,
      addRequisitesLimit,
      removeRequisitesLimit,
      validateRequisitesLimits,
      handlePlanUpdate,
      onNightDisputeAutoCloseHourChange,
      onNightDisputeAutoCloseMinutesChange,
      loadAntiFraudSettings,
      AntiFraudAlertRule,
      autoCabinetBlockHoursText
    }
  },
  async beforeMount() {
    const store = useStore();
    await store.dispatch("currencyMethods/loadList");
  }
})
</script>
